<template>
  <div
    id="work-config-component"
    @mouseleave="onlineCredentialAuditorDialogVisible = false"
  >
    <!-- 缩小 -->
    <span v-if="!workConfigVisible" @click="workConfigVisible = true">
      <svg-icon
        class="cursorPointer mini-switch-off"
        :icon-class="randomIcon()"
      ></svg-icon>
    </span>

    <!-- 展开 -->
    <div
      v-else
      id="work-config-layout"
      :class="workConfigBackground"
      :style="
        ['credential_auditor'].indexOf(userInfo.userType) === -1 ||
        (credentialAuditorResults && credentialAuditorResults.length === 0)
          ? 'padding: 10px'
          : 'padding: 30px 10px 10px'
      "
    >
      <!-- － -->
      <i
        class="el-icon-minus cursorPointer mini-switch-on"
        @click="workConfigVisible = false"
      />

      <!-- 凭证审核员展示接单 switch -->
      <template v-if="['credential_auditor'].indexOf(userInfo.userType) !== -1">
        <el-button
          v-if="dispatchOrdersCnt + receiptOperateOrdersCnt > 0"
          style="margin: 0 auto 10px auto; display: block"
          size="small"
          type="warning"
          plain
          @click="dynamicAssignOrdersConfirm()"
          >转移未处理订单给其他审核员</el-button
        >

        <div style="text-align: center">
          <el-switch
            :disabled="switchDisabled"
            @change="toggleOnlineStatus($event)"
            v-bind:class="{ switchLoading }"
            style="margin-bottom: 10px"
            v-model="onlineStatus"
            active-color="#409EFF"
            inactive-color="#ff0000"
            active-text="接单"
            inactive-text="不接单"
          />
        </div>

        <el-dialog
          class="dynamic-assign-orders-dialog"
          top="20vh"
          :visible="workOffDialogVisible"
          @close="workOffDialogVisible = false"
          width="400px"
          :show-close="false"
          :close-on-click-modal="false"
        >
          <div
            v-loading="switchLoading"
            element-loading-background="rgba(255, 255, 255, 0.8)"
            element-loading-spinner="el-icon-loading"
          >
            <div class="work-off-after-text">
              目前已被指派, 卡主仍在处理中的订单数：{{ dispatchOrdersCnt
              }}<br />
              目前已被指派, 仍等待审核回单的订单数：{{ receiptOperateOrdersCnt
              }}<br /><br />
              请确认是否需要转移待处理订单给其他审核员，如要转移点击下方转移。如不转移，请等待卡主提交凭证过来，并且将其处理完毕。
            </div>
            <div style="text-align: center">
              <el-button
                size="small"
                type="warning"
                plain
                @click="dynamicAssignOrders()"
                >转移</el-button
              >
              <el-button size="small" @click="workOffDialogVisible = false"
                >不转移</el-button
              >
            </div>
          </div>
        </el-dialog>
      </template>

      <!-- 卡主 switch -->
      <template
        v-if="
          ['customer'].indexOf(userInfo.userType) !== -1 &&
          userInfo.commonUserType === 3
        "
      >
        <div style="text-align: center">
          <el-switch
            :disabled="switchDisabled"
            @change="toggleOnlineStatus($event)"
            v-bind:class="{ switchLoading }"
            style="margin-bottom: 10px"
            v-model="onlineStatus"
            active-color="#409EFF"
            inactive-color="#ff0000"
            active-text="在线"
            inactive-text="下线"
          />
        </div>
      </template>

      <!-- 管理员、凭证审核员展示线上审核员列表 -->
      <template
        v-if="
          ['credential_auditor', 'admin'].indexOf(userInfo.userType) !== -1 &&
          credentialAuditorResults &&
          credentialAuditorResults.length > 0
        "
      >
        <el-badge
          class="online-credential-auditor-count"
          :value="credentialAuditorResults.length"
          :max="99"
        >
        </el-badge>
        <span @mouseenter="onlineCredentialAuditorDialogVisible = true">
          <svg-icon
            class="online-credential-auditor cursorPointer"
            style="color: green; width: 20px; height: 20px"
            icon-class="th-buildings"
          ></svg-icon>
        </span>
        <div
          v-if="onlineCredentialAuditorDialogVisible"
          class="online-credential-auditor-layout"
        >
          <div class="scroll-layout">
            <el-table stripe :data="credentialAuditorResults">
              <el-table-column label="审核员">
                <template slot-scope="scope">
                  {{ scope.row.userName }}
                </template>
              </el-table-column>
              <el-table-column label="处理中订单数">
                <template slot-scope="scope">
                  {{ scope.row.dispatchOrders }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>

      <!-- 对所有角色展示时段 -->
      <div
        class="time-content"
        :style="
          ['credential_auditor'].indexOf(userInfo.userType) === -1 &&
          credentialAuditorResults &&
          credentialAuditorResults.length > 0 // 如果不是审核员但又有线上审核员时，避免文字 icon 重叠
            ? 'margin-top: 18px'
            : ''
        "
      >
        <!-- 非卡主才出现 -->
        <template
          v-if="
            !(
              ['customer'].indexOf(userInfo.userType) !== -1 &&
              userInfo.commonUserType === 3
            )
          "
        >
          停止收单时段：<br />
          <span
            v-if="
              periodsOfSystemClosed &&
              periodsOfSystemClosed.length === 1 &&
              periodsOfSystemClosed[0] === '00:00:00-00:00:00'
            "
            class="green"
            ><div>全时段收单</div></span
          >
          <span v-else class="red">
            <div v-for="(item, index) in periodsOfSystemClosed" :key="index">
              {{ item }}
            </div>
          </span>
        </template>
      </div>
    </div>

    <!-- 凭证审核员抢单 -->
    <div
      class="wrap-get-ticket"
      v-if="['credential_auditor'].indexOf(userInfo.userType) !== -1"
    >
      <div
        class="get-ticket"
        :class="{ go: coinGoUp, lock: lockCoin }"
        @click="requestOrderArbitrate()"
      >
        <i
          :class="lockTime === 10 ? 'el-icon-s-opportunity' : 'el-icon-loading'"
        />
        抢单<span v-if="lockTime !== 10">( {{ lockTime }} )</span>
      </div>
      <img class="coin" :class="{ go: coinGoUp }" :src="coinImg" alt="" />
    </div>
    <!-- 凭证审核员抢单结束 -->
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import {
  updateCredentialAuditorOnlineStatus,
  dynamicAssignOrders,
} from "@/api/user";
import { requestOrderArbitrate } from "@/api/order";
import Cookies from "js-cookie";

export default {
  mixins: [mainCommon],
  data() {
    return {
      onlineStatus: null, // 上下线
      switchDisabled: false, // switch disabled
      switchLoading: false, // switch loading
      workConfigVisible: true, // 整体弹框
      workOffDialogVisible: false, // 转移警告弹框
      onlineCredentialAuditorDialogVisible: false, // 线上审核员列表弹框
      clockInterval: null,
      clock: null, // 倒数计时
      periodsOfSystemClosed: [], // 停止收单时段
      dispatchOrdersCnt: 0, // 卡主仍在处理中的订单数
      receiptOperateOrdersCnt: 0, // 仍等待审核回单的订单数
      credentialAuditorResults: [], // 线上审核员
      coinImg: require("@/assets/images/request-order-coin.gif"),
      coinGoUp: false,
      lockCoin: false,
      lockTimer: null,
      lockTime: 10,
      systemTime: null,
    };
  },
  created() {
    this.getClock();

    let requestOrderArbitrateTime = Cookies.get("requestOrderArbitrateTime");
    let nowTime = this.getTimeZoneYMDHIS();

    if (nowTime - requestOrderArbitrateTime < 10) {
      this.lockCoin = true;
      this.lockTime = 10 - (nowTime - requestOrderArbitrateTime);
      this.lockTimer = setInterval(() => {
        this.lockTime--;
        if (this.lockTime === 0) {
          clearInterval(this.lockTimer);
          this.coinGoUp = false;
          this.lockCoin = false;
          this.lockTime = 10;
        }
      }, 1000);
    }
  },
  watch: {
    "$store.state.app.unallocatedObj.credentialAuditorResults"(val) {
      this.credentialAuditorResults = val;
    },
    "$store.state.app.unallocatedObj.userOnlineStatus"(val) {
      this.onlineStatus = val;
    },
    "$store.state.app.unallocatedObj.periodsOfSystemClosed"(val) {
      this.periodsOfSystemClosed = val;
    },
    "$store.state.app.unallocatedObj.systemTime"(val) {
      this.systemTime = val;
    },
  },
  computed: {
    // 变换背景颜色
    workConfigBackground() {
      if (["credential_auditor"].indexOf(this.userInfo.userType) !== -1) {
        return this.onlineStatus ? "work-on" : "work-off";
      }
      return "";
    },
  },
  methods: {
    getClock() {
      this.clockInterval = setInterval(() => {
        this.clock = this.formatTime(this.systemTime);
        this.systemTime += 1000; // 每秒钟增加 1000 毫秒
      }, 1000);
    },
    formatTime(timestamp) {
      let date = new Date(timestamp);
      let options = {
        timeZone: "Asia/Shanghai",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      return date.toLocaleString("zh-CN", options);
    },
    // 转移未处理订单给其他审核员 确认方框
    dynamicAssignOrdersConfirm() {
      this.$confirm(
        `转移未处理订单给其他审核员？如果不转移，请先将手上未审核订单处理完毕。`,
        {
          confirmButtonText: "转移",
          cancelButtonText: "不转移",
          type: "warning",
        }
      )
        .then(() => {
          this.dynamicAssignOrders();
        })
        .catch(() => {});
    },
    // 转移未处理订单给其他审核员
    dynamicAssignOrders() {
      this.switchLoading = true;

      dynamicAssignOrders(this.userInfo.userId)
        .then((res) => {
          this.$notify.success(res.message);
          this.workOffDialogVisible = false;
        })
        .catch(() => {})
        .finally(() => {
          this.$store.dispatch("GetUnallocatedAll");
          this.switchLoading = false;
        });
    },
    toggleOnlineStatus($event) {
      this.onlineStatus = $event;
      this.changeOnlineStatus($event);
    },
    // 切换 onlineStatus 状态
    changeOnlineStatus(onlineStatus) {
      this.switchDisabled = true;
      this.switchLoading = true;

      updateCredentialAuditorOnlineStatus({
        onlineStatus,
        userId: this.userInfo.userId,
      })
        .then((res) => {
          if (
            !onlineStatus &&
            res.data.dispatchOrdersCnt + res.data.receiptOperateOrdersCnt > 0
          ) {
            this.dispatchOrdersCnt = res.data.dispatchOrdersCnt; // 目前已被指派, 卡主仍在处理中的订单数
            this.receiptOperateOrdersCnt = res.data.receiptOperateOrdersCnt; // 目前已被指派, 仍等待审核回单的订单数
            this.workOffDialogVisible = true; //转移警告弹框
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.onlineStatus = !onlineStatus;
          }, 1000);
        })
        .finally(() => {
          this.$store.dispatch("GetUnallocatedAll"); // 打一次小红点接口为同步
          setTimeout(() => {
            this.switchDisabled = false;
            this.switchLoading = false;
          }, 1000);
        });
    },
    // 请求仲裁单指派
    requestOrderArbitrate() {
      if (
        !Cookies.get("requestOrderArbitrateTime") ||
        this.getTimeZoneYMDHIS() - Cookies.get("requestOrderArbitrateTime") >=
          10
      ) {
        Cookies.set("requestOrderArbitrateTime", this.getTimeZoneYMDHIS());

        // 不让连点
        if (!this.lockCoin) {
          this.coinGoUp = true;
          this.lockCoin = true;
          requestOrderArbitrate(this.userInfo.userId)
            .then(() => {
              this.$notify.success("抢单成功");
              this.$store.commit("TOGGLE_RELOAD_CURRENT_PAGE_DATA", true);
              // 避免不可预期的错误，10秒后仍协助改为不需要刷新页面
              setTimeout(() => {
                this.$store.commit("TOGGLE_RELOAD_CURRENT_PAGE_DATA", false);
              }, 10000);
            })
            .finally(() => {
              this.lockTime--;
              this.lockTimer = setInterval(() => {
                this.lockTime--;
                if (this.lockTime === 0) {
                  clearInterval(this.lockTimer);
                  this.coinGoUp = false;
                  this.lockCoin = false;
                  this.lockTime = 10;
                }
              }, 1000);
            });
        }
      }
    },
    randomIcon() {
      let textArr = [
        "th-diceone",
        "th-dicetwo",
        "th-dicethree",
        "th-dicefour",
        "th-dicefive",
        "th-dicesix",
      ];
      return textArr[Math.floor(Math.random() * textArr.length)];
    },
  },
};
</script>

<style lang="scss" scoped>
#work-config-component {
  .online-credential-auditor-close {
    float: right;
    font-size: 23px;
  }
  .online-credential-auditor-layout {
    padding: 3px;
    width: 220px;
    box-shadow: 1px 1px 6px 1px #a7a7a7;
    background-color: #fff;
    border-radius: 2px;
    // animation: fadeInUp 0.6s forwards;
    border-radius: 2px;
    position: absolute;
    left: 0;
    bottom: 100%;
    .scroll-layout {
      height: 170px;
      overflow-y: auto;
    }
  }
  .online-credential-auditor-count {
    position: absolute;
    left: 16px;
    top: 0;
    z-index: 20001;
  }
  .online-credential-auditor {
    position: absolute;
    left: 7px;
    top: 7px;
  }
  .work-off-after-text {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #e6a23c;
  }
  .mini-switch-off {
    animation: fadeInUp 0.6s forwards;
    text-align: center;
    width: 24px;
    height: 24px;
    background-color: #fff;
    // border-radius: 20%;
    line-height: 24px;
    position: fixed;
    left: 20px;
    bottom: 20px;
    color: #000;
    font-size: 20px;
    z-index: 20000;
  }
  #work-config-layout.work-off {
    background-color: #fff7f0;
  }

  #work-config-layout.work-on {
    background-color: #edf3ff;
  }
  #work-config-layout {
    width: 220px;
    font-size: 15px;
    box-shadow: 1px 1px 6px 1px #a7a7a7;
    position: fixed;
    left: 20px;
    bottom: 20px;
    z-index: 20000;
    border-radius: 2px;
    animation: fadeInUp 0.6s forwards;
    background-color: #fff;

    .mini-switch-on {
      font-weight: 600;
      position: absolute;
      right: 0;
      top: 0;
      padding: 7px;
    }

    .time-content {
      line-height: 26px;
      text-shadow: 0px 0px 1px #b3b3b3;
      font-size: 15px;

      .clock {
        font-size: 16px;
        color: #ff9898;
        font-weight: 600;
        letter-spacing: 1.7px;
      }
      .green {
        font-size: 16px;
        color: #67c23a;
        font-weight: 600;
        width: 100%;
        display: inline-block;
        text-align: center;
        letter-spacing: 1.7px;
        text-shadow: -0.4px 0.6px 0px #000;
      }
      .red {
        font-size: 16px;
        color: #ff9898;
        font-weight: 600;
        width: 100%;
        display: inline-block;
        text-align: center;
        letter-spacing: 1.7px;
      }
    }

    /deep/ {
      .el-switch__label * {
        font-size: 13px;
      }
      .dynamic-assign-orders-dialog .el-dialog__header {
        padding: 0;
      }
      .switchLoading .el-switch__core {
        animation: breathing 0.2s infinite;
      }
    }

    @keyframes breathing {
      0%,
      100% {
        opacity: 0.1;
      }

      50% {
        opacity: 0.3;
      }
    }

    @keyframes fadeInUp {
      0% {
        opacity: 0;
        bottom: -20px;
      }
      100% {
        opacity: 1;
        bottom: 20px;
      }
    }
  }
  .wrap-get-ticket {
    position: fixed;
    right: 20px;
    bottom: 120px;
    z-index: 10000;
    width: 120px;
    user-select: none;
  }
  .get-ticket {
    position: relative;
    z-index: 20;
    font-size: 15px;
    padding: 6px 0;
    height: 30px;
    line-height: 30px;
    background-color: #ff0000;
    color: #e0e0e0;
    font-weight: 600;
    border-radius: 2px;

    // border-radius: 2px;
    text-align: center;
    cursor: pointer;
    box-sizing: content-box;
    background: #7d7d7d url("~@/assets/images/request-order-button.png")
      no-repeat bottom;
    background-size: 100% 300%;
    color: #e0e0e0;
    outline: 0.2vw solid #000;
    outline-offset: -0.2vw;
    text-shadow: 4px 4px 0 #383838;
    box-shadow: 0 1px 7px 0 #383838;
    // transition: all 0.1s;
  }
  .get-ticket:hover {
    background: #7079aa url("~@/assets/images/request-order-button.png")
      no-repeat center;
    background-size: 100% 300%;
    text-shadow: 3px 3px 0 #383838;
  }
  .get-ticket:active {
    color: #fff;
    text-shadow: 2px 2px 0 #383838;
    box-shadow: 0 1px 2px 0 #383838;
  }
  .get-ticket.lock {
    background: #7079aa url("~@/assets/images/request-order-button.png")
      no-repeat top;
    text-shadow: 0 0 0 #383838;
    box-shadow: 0 0 1px 0 #383838;
    background-size: 100% 300%;
    color: #969696;
    cursor: not-allowed;
  }
  .get-ticket.go {
    animation-name: shakeAnimation;
    animation-duration: 0.3s;
  }
  @keyframes shakeAnimation {
    0% {
      transform: translateY(0);
      transform: translateX(0);
    }
    25% {
      transform: translateY(-10px);
    }
    50% {
      transform: translateY(5px);
      transform: translateX(-1px);
    }
    75% {
      transform: translateY(-2px);
    }
    100% {
      transform: translateY(0);
      transform: translateX(0);
    }
  }
  .coin {
    position: absolute;
    width: 40px;
    bottom: 0px;
    opacity: 0;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
  }
  .coin.go {
    animation: coinEffect 0.4s forwards;
  }
  @keyframes coinEffect {
    0% {
      opacity: 0;
      bottom: 0;
      animation-timing-function: ease-in;
    }
    40% {
      opacity: 1;
      bottom: 100px;
      animation-timing-function: ease-out;
    }
    50% {
      bottom: 110px;
      animation-timing-function: ease-in;
    }
    100% {
      opacity: 0;
      bottom: 0;
      animation-timing-function: ease-in;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/OnlineStatusSwitcher.vue